import { type Ref, ref, watch } from 'vue'

import { defaultTransformation, TORAH, transformationByName, type TransformationType } from '@/util/Transformations'

export function useTransformation(options?: { columnMode?: Ref<boolean>; initialName?: string }) {
  const { columnMode, initialName } = options ?? {}
  const transformation = ref<TransformationType>(initialName ? transformationByName(initialName) : defaultTransformation())
  const tikkunStyle = ref(false)
  let preOverrideTransformation: TransformationType | null = null

  // Both column mode and tikkun force Torah font. Column mode takes precedence
  // (tikkun toggle is disabled in column mode), but they share the same
  // save/restore mechanism so exiting either reverts to the user's prior choice.
  function enterTorahOverride() {
    if (!preOverrideTransformation) {
      preOverrideTransformation = transformation.value
    }
    transformation.value = transformationByName(TORAH)
  }

  function exitTorahOverride() {
    if (columnMode?.value || tikkunStyle.value) {
      return // the other override is still active
    }
    if (preOverrideTransformation) {
      transformation.value = preOverrideTransformation
      preOverrideTransformation = null
    }
  }

  watch(tikkunStyle, (enabled) => {
    if (enabled) {
      enterTorahOverride()
    } else {
      exitTorahOverride()
    }
  })

  if (columnMode) {
    watch(
      columnMode,
      (enabled) => {
        if (enabled) {
          enterTorahOverride()
        } else {
          exitTorahOverride()
        }
      },
      { immediate: true },
    )
  }

  return { tikkunStyle, transformation }
}
